var MultiTab = require('MultiTab');

module.exports.run = function (options) {
    var record = options.record;
    var history = options.history;

    record.set({ lockedBy: '', lockedByGivenName: '', lockedOn: '' });
    history.lockedBy = '';
    history.lockedByGivenName = '';
    history.lockedOn = '';
    if(record.get('isOpenedByCurrentUser')){
        record.set('isOpenedByCurrentUser', false);
        history.isOpenedByCurrentUser = false;   
    }
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordUnlock.js